var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 9,
    y1: 16.97,
    x2: 9,
    y2: 1.03,
    gradientTransform: "scale(7.11111)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M120.89 28.445v69.262l-28.445 23.324-44.09-16.07v15.93L23.395 88.25l72.746 5.688V31.574ZM96.64 31.93 55.82 7.11v16.285L18.348 34.418 7.109 48.852v32.785l16.075 7.11V46.718Zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.d4d01d94606751bad406d766260cd597.svg";
export { ForwardRef as ReactComponent };